<template>
  <CImage
    :url="properties.image"
    :alt="properties.alt ? properties.alt : 'image not found'"
  >
  </CImage>
</template>

<script>
import CImage from "../SubComponents/Image";

export default {
  name: "SimpleImage",
  components: {
    CImage
  },
  props: {
    properties: {
      type: Object,
      default: null
    },
    image_contained: {
      type: Boolean,
      default: false
    }
  }
};
</script>
